// store user details collected from the home page component
import React, { createContext, useReducer } from "react";
import { userDetailsReducer } from "../reducer/user.details.reducer";
import { upgradeReducer } from "../reducer/upgrade.reducer";
import { cckmReducer } from "../reducer/cckm.reducer";
import { otherReducer } from "../reducer/other.reducer";
import { notesReducer } from "../reducer/notes.reducer";
import { indicatorReducer } from "../reducer/indicator.reducer";

export const ContextProvider = createContext({
  userDetails: {},
  upgrade: "",
});

const AppProvider = ({ children }) => {
  const initialUserState = {
    sfdcId: "",
    username: "",
    email: "",
    phone: "",
  };
  const [userDetails, userDispatch] = useReducer(
    userDetailsReducer,
    initialUserState
  );

  const [upgrade, upgradeDispatch] = useReducer(
    upgradeReducer,
    "No License needs to be issued for this order"
  );
  const [cckm, cckmDispatch] = useReducer(
    cckmReducer,
    "Basic 4, AWS, 12-month term"
  );
  const [other, otherDispatch] = useReducer(otherReducer, "");
  const [notes, notesDispatch] = useReducer(notesReducer, "");
  const [indicator, indicatorDispatch] = useReducer(indicatorReducer, "");

  return (
    <ContextProvider.Provider
      value={{
        userDetails,
        userDispatch,
        upgrade,
        upgradeDispatch,
        cckm,
        cckmDispatch,
        other,
        otherDispatch,
        notes,
        notesDispatch,
        indicator,
        indicatorDispatch,
      }}
    >
      {children}
    </ContextProvider.Provider>
  );
};

export default AppProvider;
